// @ts-check
import React from 'react';
import styles from './ChooseEntityNotice.module.scss';

const ChooseEntityNotice = () => (
  <div className={styles.notice}>
    Choose an Organization or Location from the dropdown above to edit settings.
  </div>
);

export default ChooseEntityNotice;
